const isnumber = (str) => {
  if (typeof str !== "string") return false; // Validate input type
  // Regex for integers or floating-point numbers
  const numericPattern = /^[+-]?\d+(\.\d+)?$/;
  return numericPattern.test(str);
}

const tokenize = (start, end, errors) => {
  let pattern = /(\d+|[\w+]|[\W+])/g;
  let tokensStart = start.match(pattern);
  let tokensEnd = end.match(pattern);
  let arrs = {
    start: [],
    end: []
  };
  let i;
  if (tokensStart.length !== tokensEnd.length) {
    return false
  }
  for (i = 0; i < tokensStart.length; i++) {
    if (tokensStart[i].length !== tokensEnd[i].length) {
      return false;
    }
    if (isnumber(tokensStart[i]) && (tokensStart[i].length > 15)) {
      errors.startvalue = "test_maximum_15_digits_allowed";
      errors.endvalue = "test_maximum_15_digits_allowed";
      return false;
    }
    if (!isNaN(tokensStart[i]) && tokensStart[i] !== ' ') {
      if (!isNaN(tokensEnd[i]) && Number(tokensEnd[i]) >= Number(tokensStart[i])) {
        arrs.start.push({
          type: 'number',
          value: Number(tokensStart[i]),
          length: tokensStart[i].length
        });
        arrs.end.push({
          type: 'number',
          value: Number(tokensEnd[i]),
          length: tokensStart[i].length
        });
      } else {
        return false;
      }

    } else {
      let tokensStartCode = tokensStart[i].charCodeAt(0);
      let tokensEndCode = tokensEnd[i].charCodeAt(0);
      if (tokensStartCode >= 65 && tokensStartCode <= 90) {
        if (tokensEndCode >= 65 && tokensEndCode <= 90 && tokensEndCode >= tokensStartCode) {
          arrs.start.push({
            type: 'char',
            value: tokensStartCode,
            length: 1
          });
          arrs.end.push({
            type: 'char',
            value: tokensEndCode,
            length: 1
          });
        } else {
          return false;
        }
      } else if (tokensStartCode >= 97 && tokensStartCode <= 122) {
        if (tokensEndCode >= 97 && tokensEndCode <= 122 && tokensEndCode >= tokensStartCode) {
          arrs.start.push({
            type: 'char',
            value: tokensStartCode,
            length: 1
          });
          arrs.end.push({
            type: 'char',
            value: tokensEndCode,
            length: 1
          });
        } else {
          return false;
        }
      } else {
        if (tokensStartCode === tokensEndCode) {
          arrs.start.push({
            type: 'symbol',
            value: tokensStart[i],
            length: 1
          });
          arrs.end.push({
            type: 'symbol',
            value: tokensEnd[i],
            length: 1
          });
        } else {
          return false
        }
      }
    }
  }
  return arrs;
}

const padWithZeros = (zeroString, number) => {
  return zeroString.substring(String(number).length, zeroString.length) + number;
}

const getZeroString = (n) => {
  let str = '', i = 0;
  for (; i < n; i++) {
    str = str + '0';
  }
  return str;
}

const generate = (pre, start, end, maxlength, errors) => {
  //let startTick = (new Date()).getTime();
  errors.startvalue = "test_maximum_allowed_range";
  errors.endvalue = "test_maximum_allowed_range";
  let arrs = tokenize(start, end, errors);
  if (!arrs) {
    //console.log('invalid')
    return false;
  }
  //console.log(arrs);
  let s = arrs.start, e = arrs.end, output = [], temp = [], prefixStr = '';
  let i, j, k, type, length, cursor, symbolsStr, zeroString;
  for (i = s[s.length - 1].value, type = s[s.length - 1].type, length = s[s.length - 1].length; i <= e[s.length - 1].value; i++) {
    if (s.length === 1) {
      prefixStr = pre
    }
    zeroString = getZeroString(length);
    if (type === 'char') {
      output.push(prefixStr + String.fromCharCode(i));
    } else if (type === 'number') {
      output.push(prefixStr + padWithZeros(zeroString, i))
    } else {
      // if symbol
      output.push(prefixStr + i)
      break;
    }
  }
  //Limit
  if (maxlength && output.length > maxlength) {
    return false
  }

  cursor = s.length - 2;
  symbolsStr = '';
  while (cursor >= 0) {
    temp = [];
    if (cursor === 0) {
      prefixStr = pre;
    }
    if (s[cursor].type === 'symbol') {
      symbolsStr = symbolsStr + s[cursor].value;
      if (cursor === 0) {
        for (k = 0; k < output.length; k++) {

          temp.push(prefixStr + symbolsStr + '' + output[k])
          //Limit
          if (maxlength && temp.length > maxlength) {
            return false
          }
        }
        output = temp.slice();
      }
      cursor--;
      continue;
    }
    for (j = s[cursor].value, type = s[cursor].type, length = s[cursor].length; j <= e[cursor].value; j++) {

      zeroString = getZeroString(length);
      for (k = 0; k < output.length; k++) {
        if (type === 'char') {
          temp.push(prefixStr + String.fromCharCode(j) + symbolsStr + '' + output[k])
        } else if (type === 'number') {
          temp.push(prefixStr + padWithZeros(zeroString, j) + symbolsStr + '' + output[k])
        }
        //Limit
        if (maxlength && temp.length > maxlength) {
          return false
        }
      }
    }
    output = temp.slice();
    symbolsStr = '';
    cursor--;
  }
  //console.log(output);
  //console.log("Time Taken: "+((new Date()).getTime() - startTick))
  delete errors.startvalue;
  delete errors.endvalue;
  return output;
}

export default generate;



// WEBPACK FOOTER //
// ./src/common/namegenerate.js